import {create} from "zustand";

const useDashboardResetFilterStore = create((set) => ({
    isDashboardResetFilters: false,

    setDashboardResetFilters: (state) => set({isDashboardResetFilters: state}),
}));

export default useDashboardResetFilterStore